export default __webpack_public_path__ + "static/media/aDash.c61afae6.svg";